<template>
  <b-container fluid>
    <footer>
      <b-button href="https://www.lifechanginginnovation.org/our-stories" target="_blank">Explore more stories of life-changing medical technology</b-button>
    </footer>
  </b-container>
</template>

<script>
export default {
  name: 'globalfooter'
}
</script>

<style lang="scss">
  footer {
    text-align: center;
    padding: 5em 0;
    a.btn {
      background: $blue;
      border: 2px solid $blue;
      border-radius: 100px;
      color: $black;
      padding-left: 4em;
      padding-right: 4em;
      transition: background ease-in .3s;
      white-space: normal;
      @media all and (max-width: $screen-md) {
        padding-left: 1em;
        padding-right: 1em;
        padding-top: 2em;
        padding-bottom: 1.75em;
      }
      &:hover,
      &:focus {
        background: $blue;
        border: 2px solid $blue;
        color: $black;
        text-decoration: underline;
      }
    }
  }
</style>
